export const mergeInitialData = <T extends Record<string, unknown>>(
  current?: T,
  initialData?: Partial<T>,
): T | undefined => {
  if (!current && !initialData) {
    return current;
  }

  return {
    ...(current ?? ({} as T)),
    ...(initialData ?? {}),
  };
};
